import { forwardRef, type Ref, type SVGProps } from "react";

function SvgThumbDownOutlined(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.2 9.6h.533c.7 0 1.267-.567 1.267-1.267V3.267C13 2.567 12.433 2 11.733 2H11.2c-.7 0-1.267.567-1.267 1.267v5.066c0 .7.567 1.267 1.267 1.267Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.933 8.267 8.4 11.733v1.6a.667.667 0 0 1-.667.667h-.066a1.6 1.6 0 0 1-1.534-2.067l.6-2.066H3.267a1.333 1.333 0 0 1-1.307-1.587l.667-3.467A1.333 1.333 0 0 1 3.933 3.6h6"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgThumbDownOutlined);
export default ForwardRef;
